import { render, staticRenderFns } from "./ADeckOfCards.vue?vue&type=template&id=68657954&scoped=true"
import script from "./ADeckOfCards.vue?vue&type=script&lang=ts"
export * from "./ADeckOfCards.vue?vue&type=script&lang=ts"
import style0 from "./ADeckOfCards.vue?vue&type=style&index=0&id=68657954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68657954",
  null
  
)

export default component.exports